import type { IPaymentStatus } from './invoice';

export enum EContractStatus {
  EM_DIA = 1,
  AGUARDANDO_PAGAMENTO = 2,
  SUSPENSO = 3,
  CANCELADO = 4,
  ATRASADO = 7,
  FINALIZADO = 9,
  TRIAL = 10,
  INADIMPLENTE = 11,
}

interface IPaymentMethod {
  id: EContractStatus;
  name: string;
}

export interface ISubscriptions {
  id: number;
  first_invoice_id: number;
  frequency_details: IFrequency;
  payment_charges: number;
  cycles: number;
  card_number: string;
  unlimited_installment: boolean;
  total_price: number;
  unit_price: number;
  amount: number;
  created_at: string;
  updated_at?: string;
  credited_at?: string;
  received_at?: string;
  initial_date: string;
  canceled_at?: string;
  next_charge_date: string;
  charge_email?: string;
  payment_status: IPaymentStatus;
  payment_method: IPaymentMethod;
  producer: IProducer;
  customer: IProducer;
  affiliate: IAffiliate;
  product: IProduct;
  currency?: string;
}

export interface ISubscriptionInvoice {
  invoice_id: number;
  id: number;
  payment_status: IPaymentStatus;
  payment_method: IPaymentMethod;
  installments: number;
  chargeback: boolean;
  recovery: boolean;
  created_at: Date;
  expired_at: any;
  refunded_at: any;
  transaction_value: number;
  quotation_value: number;
  receive_at: any;
  order?: number;
  sale_value: number;
  rate_amount: number;
  comission_amount: number;
  partner_amount: number;
  amount: number;
  anticipation_amount: number;
  refunded_amount: number;
  net_income: number;
  others_values: number;
  credited_at: string;
  producer_id: number;
  received_at: string;
  commission_amount: number;
  checkout_recovery_link: any;
  boleto_recovery_link: any;
  card_brand: string;
  affiliate: IAffiliate;
  product: IProduct;
  bankslip_url: string;
}

export interface IProduct {
  id: number;
  title: string;
  allows_card: number;
  image: string;
  producer_id: number;
  sku: string;
}

interface IAffiliate {
  id: number;
  email?: string;
  name?: string;
}

interface IProducer {
  id: number;
  name: string;
  business_name: string;
  email: string;
  celphone: string;
}

interface IFrequency {
  frequency: string;
  frequency_type: string;
  frequency_reference: number;
  total_cycles: string;
  number_of_charges: string;
}

export interface ISubscriptionsStatus {
  id: number;
  value: string;
  label: string;
}

export interface ICancelReason {
  id: number;
  name: string;
  status: number;
  created_at: string;
  updated_atd: string;
}
